import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const jobTypeApi = createApi({
  reducerPath: "job-types",
  tagTypes: ["JobTypes"],
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({

    // ✅ Get all job types
    getAllJobTypes: builder.query({
        query: ({ pageno, search ,role ,sortOrder , sortBy, limit}) => {
          let url = `${role}/job-types?pageno=${pageno}`;

          if (search) {
            url += `&search=${encodeURIComponent(search)}`;
          }
          if (sortBy) {
            url += `&sortBy=${sortBy}`;
          }
          if (sortOrder) {
            url += `&sortOrder=${sortOrder}`;
          }
          if (limit) {
            url += `&limit=${limit}`;
          }

          return {
            url,
            method: "GET",
          };
        },
        transformResponse: (res) => res,
        providesTags: ["JobTypes"],
      }),

    // ✅ Update job type status
    updateJobTypeStatus: builder.mutation({
      query: ({id,role}) => ({
        url: `${role}/job-type/status/${id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
      invalidatesTags: ["JobTypes"],
    }),

    // ✅ Get single job type by ID
    getJobTypeById: builder.query({
      query: (id) => `admin/job-type/${id}`,
      transformResponse: (res) => res?.body,
      providesTags: ["JobTypes"],
    }),

    // ✅ Add new job type
    addNewJobType: builder.mutation({
      query: ({data,role}) => ({
        url: `${role}/job-type`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["JobTypes"],
    }),

    // ✅ Update job type
    updateJobType: builder.mutation({
      query: ({id,data,role}) => ({
        url: `${role}/job-type/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["JobTypes"],
    }),

    // ✅ Delete job type
    deleteJobType: builder.mutation({
      query: ({id,role}) => ({
        url: `${role}/job-type/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["JobTypes"],
    }),

    restoreToDefaults : builder.mutation({
      query: () => ({
        url: `contractor/job-types/restore-defaults`,
        method: "PUT",
      }),
      invalidatesTags: ["JobTypes"],
    })
    
  }),
});

export const {
  useGetAllJobTypesQuery,
  useGetJobTypeByIdQuery,
  useAddNewJobTypeMutation,
  useUpdateJobTypeMutation,
  useUpdateJobTypeStatusMutation,
  useDeleteJobTypeMutation,
  useRestoreToDefaultsMutation  
} = jobTypeApi;
